<template>
    <div class="title">
        <!-- <Select v-model="model1" style="width:200px">
            <Option v-for="item in cityList" :value="item.value" :key="item.value">{{ item.label }}</Option>
        </Select>
        <div @click="click">戳我</div> -->
        <Sider hide-trigger :style="{background: '#fff'}">
            <Menu active-name="" theme="light" width="auto" :open-names="['']" >
                <Submenu name="1">
                    <template slot="title">
                        <Icon type="md-home" />
                        首页
                    </template>
                    <MenuItem name="1-1"><router-link to="/" >数据概览</router-link></MenuItem>
                </Submenu>
                <Submenu name="2">
                    <template slot="title">
                        <Icon type="ios-navigate"></Icon>
                        网站设置
                    </template>
                    <MenuItem name="2-1"><router-link to="/website">信息设置</router-link></MenuItem>
                    <MenuItem name="2-2"><router-link to="/watermark">水印设置</router-link></MenuItem>
                    <MenuItem name="2-3"><router-link to="/sowing_map">轮播图设置</router-link></MenuItem>
                    <MenuItem name="2-4"><router-link to="/bak" >数据备份管理</router-link></MenuItem>
                    <MenuItem name="2-5"><router-link to="/personal" >个人信息</router-link></MenuItem>
                </Submenu>
                <Submenu name="3">
                    <template slot="title">
                        <Icon type="ios-keypad"></Icon>
                        管理员管理
                    </template>
                    <MenuItem name="3-1"> <router-link to="/admin"> 管理员列表 </router-link> </MenuItem>
                    <MenuItem name="3-2"> <router-link to="/adminrole" >角色管理 </router-link> </MenuItem>
                    <MenuItem name="3-3"> <router-link to="/adminauth" >权限管理</router-link> </MenuItem>
                </Submenu>
                <Submenu name="4">
                    <template slot="title">
                        <Icon type="ios-alert" />
                        会员管理
                    </template>
                    <MenuItem name="4-1"><router-link to="/user" >会员列表</router-link> </MenuItem>
                <!-- </Submenu> -->
                </Submenu>
                <Submenu name="5">
                    <template slot="title">
                        <Icon type="ios-aperture" />
                        文章管理
                    </template>
                    <MenuItem name="5-1"><router-link to="/article">文章列表</router-link></MenuItem>
                    <MenuItem name="5-2"><router-link to="/articlecategory" >文章分类</router-link></MenuItem>
                </Submenu>
                <Submenu name="6">
                    <template slot="title">
                        <!-- <Icon type="merge"></Icon> -->
                        <Icon type="ios-camera" />
                        标签管理
                    </template>
                    <MenuItem name="6-1"><router-link to="/label">标签列表</router-link></MenuItem>
                </Submenu>
                <Submenu name="7">
                    <template slot="title">
                        <Icon type="ios-medical" />
                        友情链接管理
                    </template>
                    <MenuItem name="7-1"><router-link to="/friendlink">友情链接列表</router-link></MenuItem>
                </Submenu>
                <Submenu name="8">
                    <template slot="title">
                        <Icon type="ios-timer" />
                        闲言碎语管理
                    </template>
                    <MenuItem name="8-1"><router-link to="/gossip">闲言碎语列表</router-link></MenuItem>
                </Submenu>
                <Submenu name="9">
                    <template slot="title">
                        <Icon type="ios-heart" />
                        公告管理
                    </template>
                    <MenuItem name="9-1"><router-link to="/notice">公告列表</router-link></MenuItem>
                </Submenu>
                <Submenu name="10">
                    <template slot="title">
                        <Icon type="ios-pie" />
                        留言管理
                    </template>
                    <MenuItem name="10-1"><router-link to="/message">留言列表</router-link></MenuItem>
                </Submenu>
                <Submenu name="12">
                    <template slot="title">
                        <Icon type="ios-browsers" />
                        评论管理
                    </template>
                    <MenuItem name="12-1"><router-link to="/comment">评论列表</router-link></MenuItem>
                </Submenu>
                <Submenu name="14">
                    <template slot="title">
                        <Icon type="ios-folder-open" />
                        资源管理
                    </template>
                    <MenuItem name="14-1"><router-link to="/resource">资源列表</router-link></MenuItem>
                </Submenu>
                <Submenu name="11">
                    <template slot="title">
                        <Icon type="md-basket" />
                        商品管理
                    </template>
                    <MenuItem name="11-1"><router-link to="/product">商品列表</router-link></MenuItem>
                    <MenuItem name="11-2"><router-link to="/productcategory" >商品分类列表</router-link></MenuItem>
                    <MenuItem name="11-3"><router-link to="/productbrand" >商品品牌列表</router-link></MenuItem>
                    <MenuItem name="11-4"><router-link to="/productmodel" >商品模型列表</router-link></MenuItem>
                    <MenuItem name="11-5"><router-link to="/productspec" >商品规格列表</router-link></MenuItem>
                </Submenu>
                <!-- </Submenu> -->
                <Submenu name="13">
                    <template slot="title">
                        <Icon type="ios-analytics"></Icon>
                        订单管理
                    </template>
                    <MenuItem name="13-1"><router-link to="/" >订单列表</router-link></MenuItem>
                </Submenu>
            </Menu>
        </Sider>
    </div>

</template>
<style scoped>
    a{
        color:black;
    }
    .router-link-active{
        color:#2d8cf0;
    }
</style>
<script>
// es6语法 返回当前对象
export default {
  name:"appMenu",
  data(){
      return {
                // theme2: 'light',
                // theme2: 'dark',
            }
      },
      methods:{
        //   click:function(){
        //       console.log(this.model1)
        //   }
      },
      created(){
          this.model1 = "Paris"
      }
  }
</script>



